import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class InventoryTransferBus extends BaseBus
{
    constructor() {
        super(null);
    }

    CID(): any {
        return this.inventoryLocationXrefid;
    }
    initialize(data: InventoryTransferBus) {
        super.initialize(data);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: InventoryTransferBus) {
        super.setFromForm(data);

    }
    setId(id: any) {
        this.inventoryLocationXrefid = id;
    }

    setBeforeSave() {
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
    }
    inventoryLocationXrefid: string;
    inventoryId: string;
    newInventoryLocationId: string;
    quantity: number;
    orderId: string;
}
